import React from "react";
import "./app.css";
import ClassificationWizard from "./classificationwizard";
import { MultiStepWizard } from "@atlassiansox/microscopekit";
var WizardHelpContent = function (props) {
    var NoneName = "None";
    var handleSubmit = function () {
        if (props.onSubmit) {
            props.onSubmit();
        }
        props.closeClicked();
    };
    return (React.createElement("div", { className: "multistepwizard-container" },
        React.createElement(MultiStepWizard, { title: "Update Data Classified Service Descriptor", steps: [
                {
                    name: "UGC",
                    body: React.createElement("div", { className: "wizard-step-content" },
                        React.createElement("h5", null, "How do I classify UGC: User Generated Content?"),
                        React.createElement("p", null, "Does your service call content service to fetch anything from the list below using UUID or ARI?"),
                        React.createElement("ul", null,
                            React.createElement("li", null, "Jira/Confluence page content: UGC/Primary"),
                            React.createElement("li", null, "Company or org name associated with UGC/Primary: UGC/Label"),
                            React.createElement("li", null, "Configuration related to UGC/Primary: UGC/Configuration"),
                            React.createElement("li", null, "UUID or ARI: UGC/PrimaryIdentifier")),
                        React.createElement("p", null,
                            "Click ",
                            React.createElement("a", { href: "https://developer.atlassian.com/platform/data-classification/labeling-schema/labels/#user-generated-content", target: "_blank" }, "UGC Reference"),
                            " for more information."),
                        React.createElement("p", null, "Select relevant UGC for your service and resources (skip if none apply): "),
                        React.createElement("div", { className: "Tutorial-answer" },
                            React.createElement(ClassificationWizard, { selected: props.selectedClassifications, setSelected: props.onSelect, classificationLabels: [
                                    { name: "UGC/Primary" },
                                    { name: "UGC/Label" },
                                    { name: "UGC/Configuration" },
                                    { name: "UGC/PrimaryIdentifier" }
                                ] })))
                },
                {
                    name: "PII",
                    body: React.createElement("div", { className: "wizard-step-content" },
                        React.createElement("h5", null, "How do I classify PII: Personally Identifiable Information?"),
                        React.createElement("p", null, "Does your service call to PRS via Atlassian Account ID and retrieve any of the sensitive data listed below?"),
                        React.createElement("ul", null,
                            React.createElement("li", null, "Atlassian Account Identifier: PII/DirectRestrictedIdentifier"),
                            React.createElement("li", null, "First and last name, email, phone number: PII/DirectRestricted"),
                            React.createElement("li", null, "ID Address, DOB, Last 4 digits of credit cards: PII/IndirectRestricted"),
                            React.createElement("li", null, "Country, zip, cloud ID (in certain cases only refer to FAQ): PII/IndirectConfidential")),
                        React.createElement("p", null,
                            "Click ",
                            React.createElement("a", { href: "https://developer.atlassian.com/platform/data-classification/labeling-schema/labels/#personally-identifiable-information", target: "_blank" }, "PII Reference"),
                            " for more information."),
                        React.createElement("p", null, "Select relevant PII your service and resource accesses (skip if none apply): "),
                        React.createElement("div", { className: "Tutorial-answer" },
                            React.createElement(ClassificationWizard, { selected: props.selectedClassifications, setSelected: props.onSelect, classificationLabels: [
                                    { name: "PII/DirectRestrictedIdentifier" },
                                    { name: "PII/DirectRestricted" },
                                    { name: "PII/IndirectRestricted" },
                                    { name: "PII/IndirectConfidential" }
                                ] })))
                },
                {
                    name: "Usage",
                    body: React.createElement("div", { className: "wizard-step-content" },
                        React.createElement("h5", null, "Does your service access data related to user activities?"),
                        React.createElement("ul", null,
                            React.createElement("li", null, "Page likes, mentions, reactions: Usage/DirectAction"),
                            React.createElement("li", null, "Mouse movements, time spent on page, background analytics: Usage/IndirectAction")),
                        React.createElement("p", null,
                            "Click ",
                            React.createElement("a", { href: "https://developer.atlassian.com/platform/data-classification/labeling-schema/labels/#usage-related", target: "_blank" }, "Usage Reference"),
                            " for more information."),
                        React.createElement("p", null, "Select relevant PII your service and resource accesses (skip if none apply): "),
                        React.createElement("div", { className: "Tutorial-answer" },
                            React.createElement(ClassificationWizard, { selected: props.selectedClassifications, setSelected: props.onSelect, classificationLabels: [
                                    { name: "Usage/DirectAction" },
                                    { name: "Usage/IndirectAction" },
                                    { name: "Usage/AuditLog" },
                                    { name: "Usage/ApplicationLog" },
                                    { name: "Usage/Telemetry " }
                                ] })))
                },
                {
                    name: "Other",
                    body: React.createElement("div", { className: "wizard-step-content" },
                        React.createElement("h5", null, "Does your service and resource access any of the below data types?"),
                        React.createElement("p", null,
                            "Click ",
                            React.createElement("a", { href: "https://developer.atlassian.com/platform/data-classification/labeling-schema/labels/#security-related", target: "_blank" }, "Security and other Reference"),
                            " for more information."),
                        React.createElement("div", { className: "Tutorial-answer" },
                            React.createElement(ClassificationWizard, { selected: props.selectedClassifications, setSelected: props.onSelect, classificationLabels: [
                                    { name: "Security/Credential" },
                                    { name: "Security/Secret" },
                                    { name: "Atlassian/Configuration" },
                                    { name: "Atlassian/Survey" },
                                    { name: "Atlassian/Finance" },
                                    { name: "Atlassian/Static" },
                                    { name: "Commerce/Transaction" }
                                ] })))
                },
                {
                    name: "Finish",
                    body: React.createElement("div", { className: "wizard-step-content" },
                        React.createElement("h5", null, "What should I do if my service or any of the resources do not access any data classification data types?"),
                        React.createElement("p", null,
                            "If none of the data types apply to your service, you ",
                            React.createElement("i", null, "must"),
                            " apply the ",
                            React.createElement("b", null, "None"),
                            " label:"),
                        React.createElement(ClassificationWizard, { selected: props.selectedClassifications, setSelected: props.onSelect, classificationLabels: [
                                { name: NoneName }
                            ] }),
                        React.createElement("h4", null,
                            "For more detailed description of data-types ",
                            React.createElement("a", { href: "http://go.atlassian.com/labelingSchema", target: "_blank" }, "refer to DAC")),
                        React.createElement("h4", null,
                            "Do you still have questions? Check ",
                            React.createElement("a", { href: "https://developer.atlassian.com/platform/data-classification/labeling-schema/guidelines-faq/", target: "_blank" }, "FAQ."))),
                    onNext: handleSubmit
                }
            ] })));
};
export default WizardHelpContent;
